export default "__VITE_ASSET__CEsKb7Yk__"